import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import {
  AiFillGithub,
} from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";
import Aboutcard from "../About/AboutCard";
import Timeline from "./Timeline";

function Home2() {
  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row>
          <Col md={10} className="home-about-description">
            <h2 className="section-title home-about-title">
              LET ME <span className="purple"> INTRODUCE </span> MYSELF
            </h2>
            <p className="home-about-body">
              I&apos;m a Staff Software Engineer in Applied AI at{" "}
              <b className="purple">Invisible Technologies</b>, with a background
              leading engineering teams at Mandolin, Happy Returns, and Lob. I
              build and ship AI-powered products — from multi-agent workflows to
              full-stack web systems — and I&apos;m most energized when bridging
              technical depth with team leadership.
              <br />
              <br />
              <b className="purple">Core strengths:</b> applied AI / LLM systems,
              JavaScript &amp; Go, React/Node, and scaling engineering orgs.
              <br />
              <br />
              <b className="purple">Currently exploring:</b> multi-agent
              architectures, eval-driven AI development, and practical production
              ML.
            </p>
          </Col>
        </Row>
        <Row style={{ justifyContent: "center", padding: "10px" }}>
          <Col
            md={8}
            style={{
              paddingTop: "30px",
              paddingBottom: "50px",
            }}
          >
            <Aboutcard />
          </Col>
        </Row>
        <h2 className="project-heading" id="experience">
          Professional <strong className="purple">Experience </strong>
        </h2>
        <p className="experience-resume-link">
          <Link to="/resume">View full resume</Link>
        </p>
        <br/>
        <Timeline />
        <Row>
          <Col md={12} className="home-about-social">
            <p>
              Feel free to <span className="purple">connect </span>with me
            </p>
            <ul className="home-about-social-links">
              <li className="social-icons">
                <a
                  href="https://github.com/henrychen11"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="GitHub profile"
                  className="icon-colour  home-social-icons"
                >
                  <AiFillGithub />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://www.linkedin.com/in/henrychen11/"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="LinkedIn profile"
                  className="icon-colour  home-social-icons"
                >
                  <FaLinkedinIn />
                </a>
              </li>
            </ul>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}
export default Home2;
